<template>
  <div id="app">
    <!-- <google-map /> -->
    <!-- <google-map-raw /> -->
    <!-- <div id='map' style="height: 400px; width: 100%;">
    </div> -->

    <!-- https://stackoverflow.com/questions/49882850/v-if-when-router-path-changes -->
    <!-- <nav v-if="$router.history.current.path =='/'" class="navbar" style="position: absolute;" id="dark-navbar">
      <router-link to="/" class="navbar-brand">
        <img src="./assets/img/logo/th_white.svg" width="" height="50" alt="ThriveHire" style="" id='nav-logo'>
      </router-link>
    </nav> -->
    <!-- https://vuejs.org/v2/guide/conditional.html#v-else-if -->
    <!-- <nav v-else class="navbar" style="position: absolute;" id="light-navbar">
      <router-link to="/" class="navbar-brand">
        <img src="./assets/img/logo/th_charcoal.svg" width="" height="50" alt="ThriveHire" style="" id='nav-logo'>
      </router-link>
    </nav> -->

    <!-- <nav v-if="($router.history.current.path !='/client-application-permanent-nanny') && ($router.history.current.path !='/v2')" class="navbar" style="position: absolute;" id="dark-navbar">
      <router-link to="/" class="navbar-brand">
        <img src="./assets/img/logo/NAN_logomark_RGB_Evergreen.png" width="" height="117" alt="The Nanny Co" style="" id='nav-logo'>
      </router-link>
    </nav> -->

    <div
      v-if="
        $router.history.current.path != '/family-form' &&
          $router.history.current.path != '/nanny-application-form'
      "
      style="padding-left: 15px; padding-right: 15px; position: absolute; width: calc(100%);"
    >
      <nav
        class="web-only navbar navbar-expand-lg navbar-light"
        style="margin-bottom: -96px;"
      >
        <a class="navbar-brand" href="/" style="padding-top: 0;">
          <img
            class=""
            :src="require(`./assets/img/logo/${$store.getters.logo}`)"
            width=""
            :height="$store.getters.logoHeight"
            :alt="$store.getters.agencyName"
            style=""
            id="nav-logo"
          />
        </a>
        <button
          @click="showMobileNav = !showMobileNav"
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          @click.stop
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div
          class="collapse navbar-collapse"
          id="navbarSupportedContent"
          :class="{ show: showMobileNav }"
          style="float: right;"
        >
          <div
            class="web-only search-form mr-auto"
            style="display: flex; -webkit-box-align: center; align-items: center; height: 80px;"
          ></div>
          <ul class="navbar-nav">
            <li class="nav-item" v-if="this.$store.getters.isEmployer === false && this.$store.getters.isAgent === true">
              <router-link class="nav-link" :to="{ name: 'Job Board' }"
                >Jobs</router-link
              >
            </li>
            <!-- <li class="nav-item">
              <router-link class="nav-link" :to="{ name: 'Content', params: { slug: 'about' } }">About Us</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ name: 'Organization Board' }">Organizations</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ name: 'Events' }">Events</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ name: 'Blog' }">Blog</router-link>
            </li> -->
            <li class="nav-item" v-if="!auth">
              <router-link class="nav-link" :to="{ name: 'Login' }"
                >Sign In</router-link
              >
            </li>
            <li class="nav-item" v-if="auth">
              <p class="nav-link" style="cursor: pointer;" @click="logout()">
                Logout
              </p>
            </li>
          </ul>

          <div class="header-button">
            <!-- <router-link v-if="!auth" :to="{ name: 'Employer Registration'}"><button class="buttons button-1-dark">Add an Opportunity</button></router-link> -->
            <button
              v-if="auth"
              @click="dashboardRedirect()"
              class="button button-1-dark"
            >
              My Dashboard
            </button>
          </div>
        </div>
      </nav>

      <nav
        class="mobile-only navbar navbar-light"
        style="margin-bottom: -56px;"
      >
        <a class="navbar-brand" href="/">
          <img
            :src="require(`./assets/img/logo/${$store.getters.logo}`)"
            width=""
            :height="$store.getters.logoHeight"
            :alt="$store.getters.agencyName"
            style=""
            id="nav-logo"
          />
        </a>
        <div
          class="mobile-only dropleft"
          style="float: right; margin-top: 4px; background-color: z-index: 9999;"
        >
          <button
            @click="showMobileNav = !showMobileNav"
            class="btn btn-secondary dropdown-toggle"
            style="line-height: 1; padding-bottom: 0.3rem; padding-left: 0.5rem; padding-right: 0.5rem;"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            @click.stop
          >
            <i
              class="material-icons"
              style="font-size: 24px; color: var(--coredarkcolor);"
              >menu_open</i
            >
          </button>
          <div
            class="dropdown-menu"
            aria-labelledby="dropdownMenuButton"
            :class="{ show: showMobileNav }"
            style="float: right;"
          >
            <!-- <p v-if="auth" class="dropdown-item" @click="dashboardRedirect()">My Dashboard</p>
            <router-link class="dropdown-item" :to="{ name: 'Content', params: { slug: 'about' } }">About Us</router-link>
            <router-link class="dropdown-item" :to="{ name: 'Organization Board' }">Organizations</router-link>
            <router-link class="dropdown-item" :to="{ name: 'Events' }">Events</router-link>
            <router-link class="dropdown-item" :to="{ name: 'Blog' }">Blog</router-link> -->
            <router-link v-if="this.$store.getters.isEmployer === false" class="dropdown-item" :to="{ name: 'Job Board' }"
              >Jobs</router-link
            >
            <router-link
              v-if="!auth"
              class="dropdown-item"
              :to="{ name: 'Login' }"
              >Sign In</router-link
            >
            <!-- <router-link v-if="!auth" class="dropdown-item" :to="{ name: 'Employer Registration'}">Add an Opportunity</router-link> -->
            <p v-if="auth" class="dropdown-item" @click="logout()">Logout</p>
          </div>
        </div>
      </nav>
    </div>

    <!-- <div class="center" style="max-width: 1280px;">
      <nav class="navbar navbar-expand-lg navbar-light bg-light" style="padding: 0; background-color: white !important; ">
        <router-link to="/" class="navbar-brand" style="margin-right: 0;">
          <img src="./assets/img/logo/NAN_logomark_RGB_Evergreen.png" width="" height="117" alt="The Nanny Co" style="" id='nav-logo'>
        </router-link>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav" style="color: #0c4524">
            <li class="nav-item">
              <a class="nav-link" href="#">SERVICES</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">ABOUT</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">EMPLOYMENT</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">TESTIMONIALS</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">BLOG</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">EVENTS</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">CONTACT</a>
            </li>
          </ul>
        </div>
      </nav>
    </div> -->

    <!-- https://github.com/vuejs/vue-router/issues/1490, https://jsfiddle.net/Linusborg/L7hscd8h/1528/ -->
    <router-view :key="$route.fullPath"></router-view>

    <app-footer></app-footer>
    <ErrorDialog />
    <ResultDialog />
    <ConfirmDialog />
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <!-- <div class="center footer" style="">
      <p style="font-size: 14px; padding-bottom: 12px; font-family: 'Crimson Text'">© 2020 The Nanny Company Inc.</p>
    </div> -->
  </div>
</template>

<script>
import MarkerClusterer from "@google/markerclusterer";

import GoogleMap from "./components/GoogleMap";
import GoogleMapRaw from "./components/GoogleMapRaw";

import gmapsInit from "./utils/gmaps";

import Footer from "./components/global/Footer.vue";

import axios from "axios";
import router from "./router";

import ErrorDialog from "./components/common/ErrorDialog";
import ConfirmDialog from "./components/common/ConfirmDialog";
import ResultDialog from "./components/common/ResultDialog";

import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "app",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      map: null,

      user: {},
      userID: null,
      // isCandidate: false,
      // isEmployer: false,

      showMobileNav: false
    };
  },
  created() {
    this.setupInterceptor();
    this.$store.dispatch("tryAutoLogin");

    this.userID = this.$store.getters.userID;
    if (this.userID) {
      this.getUser();
    }

    // Bugsnag.notify(new Error('Test error'))
  },
  mounted() {
    document.addEventListener("click", this.onClick);
    document.title = this.$store.getters.agencyHumanName
  },
  beforeDestroy() {
    document.removeEventListener("click", this.onClick);
  },
  components: {
    GoogleMap,
    GoogleMapRaw,
    ErrorDialog,
    ConfirmDialog,
    ResultDialog,
    Loading,
    AppFooter: Footer
  },
  computed: {
    // auth () { // Lecture 363
    //   return this.$store.getters.isAuthenticated
    // },
    // isCandidate() {
    //   if (this.user.is_candidate) {
    //     return true
    //   }
    //   else {
    //     return false
    //   }
    // },
    // isEmployer() {
    //   if (this.user.is_employer) {
    //     return true
    //   }
    //   else {
    //     return false
    //   }
    // },
    title: {
      get() {
        document.title = this.remaining;
        return this.remaining;
      },
      set(val) {
        // console.log(val)
        document.title = val;
      }
    },
    isLoading() {
      return this.$store.getters.loadingReqNumber > 0;
    }
  },
  methods: {
    setupInterceptor() {
      axios.interceptors.request.use(
        config => {
          this.showLoading();
          if (localStorage.getItem("token")) {
            config.headers["Authorization"] =
              "Token " + localStorage.getItem("token");
          }
          // https://stackoverflow.com/questions/48173717/enabling-cors-on-a-nginx-server-in-elasticbeanstalk/48721443
          config.headers["Access-Control-Allow-Origin"] = "*";
          return config;
        },
        error => {
          console.log(error);
          this.hideLoading();
          return Promise.reject(error);
        }
      );
      axios.interceptors.response.use(
        response => {
          this.hideLoading();
          return response;
        },
        error => {
          this.hideLoading();
          console.log(error);
          this.handleError(error);
        }
      );
    },
    handleError(error) {
      console.log(error);
      if (error.response.data) {
        this.showErrorDialog({
          title: "There is an error",
          errorObj: error.response.data
        });
      } else {
        this.showErrorDialog({
          title: "There is an error",
          message: error.toString()
        });
      }
      throw error;
    },
    onClick() {
      // Adding event handler to document:
      // https://stackoverflow.com/questions/41950432/vue-js-call-the-click-event-for-whole-page-document
      if (this.showMobileNav === true) {
        this.showMobileNav = false;
      }
    },
    // logout() {
    //   this.$store.dispatch("logout");
    // },
    getUser() {
      console.log(this.userID);
      axios
        .get("/api/people/?id=".concat(this.userID))
        .then(res => {
          console.log(res.data);
          this.user = res.data[0];

          // this.isCandidate = this.user.is_candidate
          // this.isEmployer = this.user.is_employer
        })
        .catch(error => {
          console.log(error);
        });
    }
    // dashboardRedirect() {
    //   this.userID = this.$store.getters.userID
    //   axios.get('/api/people/?id='.concat(this.userID))
    //     .then(res => {
    //       console.log(res.data)
    //       this.user = res.data[0]

    //       if (this.user.is_candidate) {
    //         router.replace({name: 'Candidate Dashboard'})
    //       }
    //       else if (this.user.is_employer) {
    //         router.replace({name: 'Employer Dashboard'})
    //       }
    //       else if (this.user.is_agent) {
    //         router.replace({name: 'Agent Dashboard'})
    //       }
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // }
  }
};
</script>

<style>
:root {
  --agencycolor: #feedef;
  --coredarkcolor: #ff6666;
  --coredarkercolor: #c95151;
  --secondarycolor: #f59eca;
  --secondarydarkercolor: #f386bc;
  --corelightcolor: #fff;
  --bootstrapgrey: #e9ecef;
  --skyblue: #bfe7ff;
  --thrivehiregrey: #d9d9da;
  --nannycogreen: #0c4524;
  --gcnorange: #e79271;
  --gcnteal: #85a2a8;
}

body {
  /* font-family: 'articulatcf-demibold', 'Montserrat', sans-serif; */
  font-family: "Open Sans", "Crimson Text";
  /* font-size: 13px; */
  /* line-height: 1.42857143; */
}

#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  font-family: "Quicksand", "Open Sans", "Crimson Text";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50; */
  /* margin-top: 60px; */

  /* width: 100vw; */
  /* height: 100vh; */
}

.top-level-div {
  padding-bottom: 20vh;
  padding-top: 15vh;
}
.invert-top-level-div {
  padding-bottom: -20vh;
  padding-top: -100px;
}

.center {
  text-align: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

/* @font-face {
    font-family: "Articulat Demibold";
    src: url("assets/fonts/articulatcf-demiboldoblique-webfont.woff2") format("woff2");
  } */

h1,
h2,
h3,
h4 {
  /* font-weight: normal; */
  font-family: "Quicksand", "Rajdhani", sans-serif, "Open Sans";
  text-transform: uppercase;
}

h1 {
  /* font-family: 'articulatcf-demibold', 'Open Sans', 'Lato'; */
  color: var(--coredarkcolor);
  /* font-weight: 300; */
}

h2 {
  /* font-family: 'articulatcf-demibold', 'Open Sans'; */
  color: var(--coredarkcolor);
}

h3 {
  /* font-family: 'articulatcf-demibold', 'Open Sans', 'Lato'; */
  color: var(--coredarkcolor);
}

h4 {
  /* font-family: 'articulatcf-regular', 'Open Sans', 'Lato'; */
}
h5 {
  /* font-family: 'articulatcf-regular', 'Open Sans', 'Lato'; */
  /* color: var(--coredarkcolor); */
}

p {
  /* font-family: 'articulatcf-regular', 'Open Sans', 'Lato'; */
  /* font-family: 'Open Sans'; */
  margin-bottom: 0;
}

.dashboard-heading {
  font-family: "articulatcf-demibold", "articulatcf-regular", "Open Sans",
    "Lato";
  /* margin-top: 10px; */
}

/* https://stackoverflow.com/questions/10270891/newline-in-models-textfield-not-rendered-in-template
  https://www.w3schools.com/tags/tag_pre.asp */
pre {
  font-family: "Quicksand", "Open Sans", "Crimson Text", "articulatcf-regular",
    "Lato";
  font-size: 100%;
  /* overflow-x: hidden; */
  /* overflow-wrap: break-word; */
  /* Prevent side scrolling of long lines */
  white-space: pre-wrap; /* https://mediatemple.net/blog/tips/considerations-for-styling-the-pre-tag/ */
  margin-bottom: 0;
}
pre p {
  margin-bottom: 10px;
}
pre h3 {
  margin-top: 15px;
}
pre h4 {
  margin-top: 15px;
}
pre h5 {
  margin-top: 15px;
}
pre img {
  margin-top: 8px;
  margin-bottom: 8px;
}

small {
  /* font-family: 'articulatcf-regular', 'Lato'; */
}

ul {
  margin-bottom: 0;
}

li {
  /* font-family: 'articulatcf-regular', 'Open Sans', 'Lato'; */
}

a {
  /* font-family: 'articulatcf-regular', 'Open Sans', 'Lato'; */
}
a:hover {
  text-decoration: none;
}

input {
  /* font-family: 'articulatcf-regular', 'Open Sans', 'Lato'; */
  font-family: "Quicksand", "Open Sans", "Crimson Text";
}
input::placeholder {
  font-family: "Quicksand", "Open Sans", "Crimson Text";
  font-size: 0.8rem;
}
textarea {
  /* font-family: 'articulatcf-regular', 'Open Sans', 'Lato'; */
}

.delete-text {
  color: red;
  cursor: pointer;
}

/* --------- BUTTONS --------- */
.btn {
  border: none;
}

.btn-lg {
  font-size: 1.1rem;
}

.btn-primary {
  background-color: var(--coredarkcolor);
  font-weight: 600;
}
.btn-primary:hover {
  background-color: var(--thrivehiregrey);
  color: var(--coredarkcolor);
}
.btn-outline-primary {
  /* border: 1px solid #5289B9; */
  color: #5289b9;
}

.btn-secondary {
  /* background-color: #5289B9; */
  /* background-color: var(--corelightcolor); */
  background-color: var(--bootstrapgrey);
  color: var(--coredarkcolor);
  /* text-transform: uppercase; */
  /* font-family: 'Lato'; */
  /* font-weight: 700; */
}
.btn-secondary:hover {
  /* background-color: #49759c; */
  background-color: var(--thrivehiregrey);
  color: var(--coredarkcolor);
  /* font-weight: 700; */
}
.btn-outline-secondary {
  /* border: 1px solid #5289B9; */
  /* color: #5289B9; */
}

.btn-grey {
  background-color: var(--bootstrapgrey);
  color: var(--coredarkcolor);
}
.btn-grey:hover {
  background-color: var(--coredarkcolor);
  color: var(--corelightcolor);
}

/* This is styling copied over from mylisting */
.buttons {
  /* font-size: 13px; */
  /* padding: 14px 40px; */
  /* -webkit-transition: all .2s ease; */

  display: inline-block;
  transition: all 0.2s ease;
  overflow: hidden;
  border-radius: 3px;
  line-height: 16px;
  font-weight: 700;
}
/* The Add an Opportunity button top right */
.header-button {
  align-items: center;
  height: 50px;
  /* padding: 15px 25px; */
}
.header-button button {
  padding: 15px 25px;
}
/* .header-button router-link {
    padding: 15px 25px;
  } */

.button-1 {
  color: var(--coredarkcolor);
  border: none;
  background: #fff;
  font-size: 14px;
  /* font-weight: 700; */
}
.button-1:hover {
  color: #fff;
  cursor: pointer;
  background: var(--coredarkcolor);
}
.button-1-dark {
  color: var(--corelightcolor);
  border: none;
  background: var(--coredarkcolor);
  font-size: 14px;
}
.button-1-dark:hover {
  color: var(--coredarkcolor);
  cursor: pointer;
  background: var(--thrivehiregrey);
}

.landing-button {
  min-width: 165px;
  font-family: "articulatcf-demibold", "Montserrat";
  font-weight: 800;
  margin-top: 20px;
}

.mylisting-button {
  min-width: 135px;
  text-align: center;
  font-family: "Quicksand", "Open Sans";
  font-weight: 600;
  /* margin-top: 20px; */
  padding: 13px 25px;
  border-radius: 0px;
  font-size: 12px;
  /* height: 48px; */
  -webkit-box-align: center;
  align-items: center;
  position: relative;
  z-index: 0;
  -webkit-box-pack: center;
  justify-content: center;
  white-space: nowrap;
  border: 2px solid #0c4524;
  border: none;
  /* margin-top: 10px; */
  /* background-size: 200% 100%;
    background-position: right bottom;
    transition: all .25s ease-out; */
}

/* This is to get rid of underlining for router links used as buttons */
a.mylisting-button:hover {
  text-decoration: none;
}

.dark-button {
  color: white;
  /* background-color: white; */
  /* Add a shadow over the search button left to right when you hover over it */
  /* https://codepen.io/kay8/pen/azKbjN */
  /* https://stackoverflow.com/questions/17212094/fill-background-color-left-to-right-css */
  background: linear-gradient(
    to right,
    var(--coredarkercolor) 50%,
    var(--coredarkcolor) 50%
  );
  background-size: 200% 100%;
  background-position: right bottom;
  transition: all 0.25s ease-out;
}
.dark-button:hover {
  color: #fff;
  background-position: left bottom;
  /* background-color: #0c4524; */
}

.secondary-button {
  color: #fff;
  /* color: var(--coredarkcolor); */
  background: linear-gradient(
    to right,
    var(--secondarydarkercolor) 50%,
    var(--secondarycolor) 50%
  );
  background-size: 200% 100%;
  background-position: right bottom;
  transition: all 0.25s ease-out;
}
.secondary-button:hover {
  color: #fff;
  background-position: left bottom;
}

.danger-button {
  color: #fff;
  background: linear-gradient(to right, #222 50%, #333 50%);
  background-size: 200% 100%;
  background-position: right bottom;
  transition: all 0.25s ease-out;
}
.danger-button:hover {
  color: #fff;
  background-position: left bottom;
}
/* --------------------- */

/* ------ NAVBAR ------- */
.nav-item {
  margin-right: 15px;
  font-size: 13px;
  color: var(--corelightcolor);
}

.dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
  border: none;
}
/* --------------------- */

.footer {
  /* background-color: white;
    border-top: 1px solid #ead9cf;
    text-align: right;
    margin-bottom: 0;
    width: auto;
    width: 80%;
    max-width: 1280px;
    padding-top: 24px;
    padding-bottom: 24px; */
}

.footer p {
  margin-bottom: 0;
}

/* ------ USER PROFILES ------ */
.profile-tile {
  border-radius: 6px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  padding: 1.5rem;
  margin-top: 40px;
}

.profile-form label {
  /* font-family: 'articulatcf-demibold', 'Lato'; */
  font-weight: 600;
  margin-top: 15px;
}
.profile label {
  /* font-family: 'Lato'; */
  font-weight: 600;
  margin-top: 15px;
  margin-bottom: 2px;
}
.profile .top-label {
  margin-top: 0;
}
.field-of-fields label {
  /* font-family: 'articulatcf-demibold', 'Lato'; */
  color: var(--coredarkcolor);
  /* color: grey; */
  /* font-size: 0.8rem; */
  font-weight: 600;
  margin-top: 25px;
  margin-bottom: 2px;
}
.field-of-fields .top-label {
  margin-top: 0;
}

/* This is the styling for each option in a multi select list */
.form-check label {
  font-weight: 400;
  /* margin-bottom: 3px; */
  margin-top: 2px;
  color: var(--coredarkcolor);
}

/* Classes that get attached to form fields that fail vuelidation */
.invalid label {
  color: red;
}
.invalid small {
  color: red;
}

.social-icon {
  /* margin-top: 8px; */
  margin-right: 2px;
  margin-left: 2px;
  height: 25px;
}

.shaded-label {
  background-color: var(--bootstrapgrey);
  width: 100%;
  padding: 10px;
  border-bottom: 7px solid var(--corelightcolor);
  /* margin-bottom: 100px; */
}
.profile-section {
  margin-left: 10px;
  margin-right: 10px;
}

/* ------------- */

.dashboard-button {
  background-color: var(--thrivehiregrey);
  /* background-color: var(--bootstrapgrey); */
  /* background-color: var(--coredarkcolor); */
  color: var(--corelightcolor);
  /* margin-right: 2px; */
  border-right: 2px solid white;
  padding-top: 6px;
  padding-bottom: 6px;
  cursor: pointer;
  /* font-family: 'articulatcf-demibold', 'Open Sans', 'Lato'; */
  font-weight: 700;
}
.dashboard-button-active {
  background-color: var(--thrivehiregrey);
  background-color: var(--coredarkcolor);
  color: var(--corelightcolor);
  /* margin-right: 2px; */
  /* padding-top: 6px; */
  /* padding-bottom: 6px; */
}

/* -------- RICH TEXT EDITOR --------- */

.editor__content {
  border: 1px solid #ced4da;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  color: #495057;
  font-size: 1rem;
  /* min-height: 100px; */ /* This does not work */
}
/* Get rid of the outline around the text in the tiptap editor */
.ProseMirror:focus {
  outline: none;
}
/* Sets the default minimum height of the rich text editor area */
.ProseMirror {
  min-height: 100px;
}

.editor__content p {
  margin-bottom: 0px;
}

/* ----------------------------------- */

/* -- CALENDAR/DATE PICKER -- */

.vdp-datepicker input {
  border-width: 0px;
  width: 100%; /* Make the inner date picking box fill the entire box */
}
.vdp-datepicker input[type="text"]:focus {
  box-shadow: none;
  border: none;
}

/* ----------------------------------- */

/* This is used for candidate registration, employer registration, password reseting */
/* ------- Bootstrap sign up form ------- */
/* https://getbootstrap.com/docs/4.1/examples/sign-in/ - https://getbootstrap.com/docs/4.1/examples/sign-in/signin.css */

.registration-form {
  height: 100vh;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 40px;
  background-color: #f5f5f5;
}

.form-signup {
  width: 100%;
  max-width: 330px;
  /* min-width: 300px; */
  padding: 15px;
  margin: auto;
}
.form-signup .checkbox {
  font-weight: 400;
}
.form-signup .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}

.form-control {
  /* font-family: 'articulatcf-regular'; */
}
/* ---------------------- */

/* https://laracasts.com/discuss/channels/vue/vue-modal-make-it-scrollable-instead-of-background */
/* Restrict the height of modals so that they are fully visible on mobile */
.v--modal-overlay.scrollable .v--modal-box {
  max-height: 90vh;
  overflow-y: auto;
}

.content-block {
  max-width: 650px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 15px;
}
.content-block img {
  max-width: 100%;
}

/* ------- Styling for informational pages like about us, our team, etc. -------- */
.informational-heading {
  margin-top: 25px;
}
.informational-subheading {
  margin-top: 25px;
}
.informational-text-block {
  margin-bottom: 10px;
}
.informational-list {
  margin-bottom: 10px;
}
/* --------------- */

/* ---- Styling for multiselector ---- */
.multiselect__tag {
  margin-bottom: 0;
  background-color: var(--coredarkcolor);
}

.multiselect__option--highlight {
  /* background: #41b883; */
  background: var(--coredarkcolor);
  /* outline: none; */
  /* color: #fff; */
}
/* ----------------------------------- */

/* --------- LISTINGS ---------- */
.listing-tile {
  background-color: var(--bootstrapgrey);
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 30px;
  padding-right: 30px;
}
/* ------------------------------ */

/* --------- DOCUMENTS ---------- */
.document {
  padding-left: 10%;
  padding-right: 10%;
  padding-top: 3%;
  padding-bottom: 3%;
}
.document p {
  margin-bottom: 15px;
  font-size: 1.2rem;
}
.document li {
  /* margin-bottom: 15px; */
  font-size: 1.2rem;
}
/* ------------------------------ */

.mobile-only {
  display: none;
}

/* ------------------- SMALL -------------------- */
@media (max-width: 768px) {
  .mobile-only {
    display: inherit;
  }
  .web-only {
    display: none;
  }

  /* ---- NAVBAR ---- */
  .landing .dropdown-item {
    color: var(--coredarkcolor);
    /* font-family: 'Open Sans'; */
    font-size: 13px;
  }

  .navbar {
    padding-left: 0;
    padding-right: 0;
  }

  /* ------- */

  h1 {
    font-size: 2rem;
    line-height: 1.1;
  }

  /* https://laracasts.com/discuss/channels/vue/vue-modal-make-it-scrollable-instead-of-background */
  /* Restrict the height of modals so that they are fully visible on mobile */
  .v--modal-overlay.scrollable .v--modal-box {
    max-height: 80vh;
    overflow-y: auto;
  }

  .grouped-buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.required-field {
  color: red !important;
  font-weight: 600 !important;
}
.required-message {
  color: red;
  font-family: "Open Sans", "Crimson Text";
  font-weight: 600;
  margin-top: 2px;
}

.vld-overlay.is-full-page {
  z-index: 10000;
}

.submit-button-section {
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
}

.text-require-notice {
  font-size: 0.8rem;
  color: var(--coredarkcolor);
}

.edit-button {
  float: right;
  cursor: pointer;
  width: 16px;
}

.form-control-file {
  font-size: 0.8rem;
}

.date-picker {
  padding: 0 !important;
}

.date-picker input {
  height: calc(1.5em + 0.75rem) !important;
  border-radius: 4px !important;
  padding-left: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue